import { KeyboardArrowDownIcon as L2RArrowDownIcon } from "@l2r-front/l2r-icons"
import { Button, Menu as UiMenu, MenuItem as UiMenuItem, styled, styledForMobile } from "@l2r-front/l2r-ui"

export const ArrowDownIcon = styled(L2RArrowDownIcon)(({ theme }) => ({
    marginLeft: theme.spacing(2),
}))

export const SelectorButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.primary.contrastText,
    borderRadius: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    color: theme.palette["text/secondary"].main,

    "&:hover": {
        backgroundColor: theme.palette.action.hover,
        border: `1px solid ${theme.palette.divider}`,
        color: theme.palette["text/secondary"].main,

        "& > svg": {
            color: theme.palette["common/black_states"].main,
        },
    },
}))

export const SelectorButtonContainer = styledForMobile("div")(() => ({
}))

export const Menu = styled(UiMenu)(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: theme.spacing(3),
    },
}))

export const MenuItem = styled(UiMenuItem)(({ theme }) => ({
    "& > svg": {
        marginRight: theme.spacing(2),
    },
}))